var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"67caf93a713546eee53738abb638b4279619a787"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["magna_app@magna-x9"]={id:"67caf93a713546eee53738abb638b4279619a787"};
      